let language = {
    "RESET_PWD_URL_PARAMS_MISSING_TITLE": "",
    "RESET_PWD_URL_PARAMS_MISSING_CONTENT": "网址参数缺失",
    
    "RESET_PWD_FAILED_TITLE": "重置密码失败",
    "RESET_PWD_FAILED_CONTENT": "密码与确认密码不同",
    
    "RESET_PWD_SUCCESS_TITLE": "重置密码成功！",
    "RESET_PWD_SUCCESS_CONTENT": "跳转到登录页面"
};

export { language }